import React, { useEffect, useState } from 'react';
import { Group, Text, Card, Title } from "@mantine/core";
import { useQuery } from '@apollo/client';
import Countdown from 'react-countdown';

import { GET_CONTESTS_BY_NAME } from "../../../queries/contest";

import "./CountdownTimer.css";

function CountdownTimer({ contestname }) {
  const [endTime, setEndTime] = useState(null);

  const {
    loading: contestQueryLoading,
    error: contestQueryError,
    data: contestQueryData,
  } = useQuery(GET_CONTESTS_BY_NAME, {
    variables: { contestname: contestname },
  });

  useEffect(() => {
    if (contestQueryLoading) {
      console.log("Loading contest data...");
    } else if (contestQueryError) {
      console.log("Error loading contest data:", contestQueryError);
    } else {
      const contestEndTime = contestQueryData.getContestByName.endat;
      console.log("End time:", contestEndTime)
      setEndTime(contestEndTime);
    }
  }, [contestQueryLoading, contestQueryError, contestQueryData]);

  const formatDate = (timestamp) => {
    const numericTimestamp = parseInt(timestamp); // Convert to a number
    if (isNaN(numericTimestamp)) {
      return "Invalid Date"; // Return this if the timestamp is not valid
    }

    const date = new Date(numericTimestamp);
    console.log("formated End Time: ", date);
    return date;
  };

  // Renderer function for the countdown
  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      return <Title py="xl" color='var(--color-negative)'>Contest has ended!</Title>;
    } else {
      return (
        <div>
          <Group position="left" className='countdown-label' mt="lg">
            <Text align='center' size="md" weight={700}>Ends in</Text>
          </Group>
          <Group position="left" spacing="xl" className='countdown-container'>
            <Card p="lg">
              <Text align="center" weight={700}>{days}</Text>
              <Text align="center" size="sm">days</Text>
            </Card>
            <Card p="lg">
              <Text align="center" weight={700}>{hours}</Text>
              <Text align="center" size="sm">hours</Text>
            </Card>
            <Card p="lg">
              <Text align="center" weight={700}>{minutes}</Text>
              <Text align="center" size="sm">minutes</Text>
            </Card>
            <Card p="lg">
              <Text align="center" weight={700}>{seconds}</Text>
              <Text align="center" size="sm">seconds</Text>
            </Card>
          </Group>
        </div>
      );
    }
  };

  if (!endTime) {
    return <div>Loading...</div>;
  }

  return <Countdown date={formatDate(endTime)} renderer={renderer} />;
}

export default CountdownTimer;
